import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";
import webConfig from 'middlewares/WebConfig';

//
// Phoenix Workflow Service URLs (field rep integration)
//

export const getStatus = (phoenixFileId, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `${webConfig.phoenixWorkflowUrl}/phoenix-at-home/status/${phoenixFileId}`,
    mountedRef: mountedRef,
    successCallback: successCallback,
    errorCallback: errorCallback
  });    
};

export const postStart = (phoenixFileId, emailAddress, phoneNumber, successCallback, errorCallback, mountedRef) => {
    WebApiRequest({
      method: HTTP_POST,
      endpoint: `${webConfig.phoenixWorkflowUrl}/phoenix-at-home/start/${phoenixFileId}`,
      payload: {
        email: emailAddress,
        phoneNumber: phoneNumber,
        notes: null,
        includeCubiCasaRequest: true, // note: the services will only include the request if the cubicasa form is also on the case, this is true here for backwards compat
        automaticShareFormIds: null
      },
      mountedRef: mountedRef,
      successCallback: successCallback,
      errorCallback: errorCallback
    });
};

//
// WebApi Service URLs (ME integration)
//

/*
[getMuellerAtHomeStatus Response Interfaces]

interface MuellerAtHomeFullStatus {
  canOpenNewInspection: boolean;
  canOfferCubiCasa: boolean;
  hasOpenInspection: boolean;
  completedReports: MuellerAtHomeReportDetails[];
  forms: MuellerAtHomeForm[];
}

interface MuellerAtHomeReportDetails {
  status: string;
  createdDate: DateTime;
  completedDate: DateTime?; 
  startRequest: MuellerAtHomeStartRequest;
  requestCount: integer;
  fulfilledRequestCount: integer;
  unableToTakeCount: integer;
  totalPhotoCount: integer;
}

interface MuellerAtHomeStartRequest {
  phoneNumber: string;
  email: string;
  notes: string;
  includeCubiCasaRequest: boolean;
  automaticShareFormIds: string[];
  requestInitiator: string;
  createWebLink: boolean;
}

interface MuellerAtHomeForm {
  id: string; //(guid)
  name: string;
}
*/

export const getMuellerAtHomeStatus = (controlIdNumber, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/mueller-at-home/status/${controlIdNumber}`,
    mountedRef: mountedRef,
    successCallback: successCallback,
    errorCallback: errorCallback
  });  
};


/* [startMuellerAtHome Response Interfaces]
interface MuellerAtHomeStartResponse {
  error: boolean;
  errorMessage: string;
}
interface MuellerAtHomeStartRequest {
  phoneNumber: string;
  email: string;
  notes: string;
  includeCubiCasaRequest: boolean;
  automaticShareFormIds: string[];
  requestInitiator: string;
  createWebLink: boolean;
}
*/
export const startMuellerAtHome = (controlIdNumber, muellerAtHomeStartRequest, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_POST,
    endpoint: `/mueller-at-home/start/${controlIdNumber}`,
    payload: muellerAtHomeStartRequest,
    mountedRef: mountedRef,
    successCallback: successCallback,
    errorCallback: errorCallback
  });
};
